/* V2 wishlist: site-breed. localStorage 'dpwl' = array van product-handles. */
if(!window.__v2wl){
  window.__v2wl = 1;
  (function(){
    var K = 'dpwl';
    function g(){ try { return JSON.parse(localStorage.getItem(K) || '[]'); } catch(e){ return []; } }
    function s(a){ try { localStorage.setItem(K, JSON.stringify(a)); } catch(e){} }
    function sync(){
      var a = g();
      document.querySelectorAll('.v2wl-btn[data-handle]').forEach(function(b){
        var on = a.indexOf(b.dataset.handle) !== -1;
        b.classList.toggle('on', on);
        b.textContent = on ? '\u2665' : '\u2661';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    window.v2wlGet = g; window.v2wlSet = s; window.v2wlSync = sync;
    document.addEventListener('click', function(e){
      var b = e.target.closest('.v2wl-btn[data-handle]');
      if(!b) return;
      e.preventDefault(); e.stopPropagation();
      var a = g(), h = b.dataset.handle, i = a.indexOf(h);
      if(i === -1){ a.push(h); } else { a.splice(i, 1); }
      s(a); sync();
      document.dispatchEvent(new CustomEvent('v2wl:change'));
    });
    function retarget(){
      document.querySelectorAll('a[href*="/apps/wishlist"]').forEach(function(x){ x.setAttribute('href', '/pages/favorieten'); });
    }
    /* Oude app-pagina automatisch doorsturen naar de nieuwe favorietenpagina */
    if(window.location.pathname.indexOf('/apps/wishlist') === 0){
      window.location.replace('/pages/favorieten');
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ retarget(); sync(); }); }
    else { retarget(); sync(); }
    /* Vangnet voor dynamisch geladen headers */
    setTimeout(retarget, 800);
  })();
}
